import { iLedger } from "@sdk/ledgers/ledgers-models";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { ledgersDefaultQueryConfig } from "./ledgers-default-query";

export const {
  slice: LedgersSlice,
  reducers: LedgersSliceReducer,
  actions: {
    setEntityQueryResults: setLedgersQueryResults,
    setEntity: setLedger,
    setEntities: setLedgers,
    patchEntity: patchLedger,
    addNewEntity: addNewLedger,
    setEntityFetchingStatus: setLedgerFetchingStatus,
    setEntitiesFetchingStatus: setLedgersFetchingStatus,
    setEntityFailedStatus: setLedgerFailedStatus,
    setEntityQueryError: setLedgersQueryError,
    resetQuery: resetLedgersQuery,
    setQueryList: setLedgerQueryList,
  },
} = CreateEntitySlice<iLedger>({
  sliceName: "ledgers",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...ledgersDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});

